export default "__VITE_ASSET__ed1a4ee6__"